import React, { useCallback, useEffect } from 'react'
import {
  Grid, makeStyles, useTheme, useMediaQuery,
} from '@material-ui/core'
import { usePosition } from 'use-position'
import { useDispatch, useSelector } from 'react-redux'

import Map from './views/Map'
import List from './views/List'
import Search from './views/Search'
import Container from './views/Container'

import {
  filteredLocationsSelector,
  querySelector,
  selectedLocationSelector,
  setUserPosition,
  setQuery,
  setSelectedLocation,
} from './slices/locator'

const useStyles = makeStyles( {
  app : {
    display : 'flex',
    position : 'absolute',
    top : 0,
    left : 0,
    right : 0,
    bottom : 0,
  },
  root : {
    flexGrow : 1,
  },
  area : {
    height : '100%',
  },
} )

function App() {
  const theme = useTheme()
  const dispatch = useDispatch()
  const query = useSelector( querySelector )
  const selected = useSelector( selectedLocationSelector )

  const matches = useMediaQuery( theme.breakpoints.down( 'xs' ) )

  const {
    latitude,
    longitude,
    error,
  } = usePosition()

  const userPositionLoading = latitude == null && longitude == null && !error

  useEffect( () => {
    dispatch(
      setUserPosition( {
        latitude,
        longitude,
      } ),
    )
  }, [ latitude, longitude, dispatch ] )

  const locations = useSelector( filteredLocationsSelector )

  const onInputChange = ( evt, value ) => {
    dispatch(
      setQuery( value ),
    )
  }

  const onChange = ( evt, value ) => {
    if ( value?.center ) {
      dispatch(
        setUserPosition( {
          longitude : value.center[0],
          latitude : value.center[1],
        } ),
      )

      dispatch( setSelectedLocation( null ) )
    } else if ( latitude && longitude ) {
      dispatch(
        setUserPosition( {
          latitude,
          longitude,
        } ),
      )
    } else {
      dispatch( setUserPosition( null ) )
    }
  }

  const classes = useStyles()
  const onClick = useCallback( ( value ) => {
    dispatch(
      setSelectedLocation( value ),
    )
  }, [ dispatch ] )

  const firstComp = matches ? (
    <Map
      key="map"
      selected={selected
                  || locations[0]}
      locations={locations}
    />
  ) : (
    <List
      loading={userPositionLoading}
      onInputChange={onInputChange}
      onChange={onChange}
      inputValue={query}
      sortedLocations={locations}
      selected={selected}
      onClick={onClick}
    />
  )

  const secondComp = matches ? (
    <List
      loading={userPositionLoading}
      onInputChange={onInputChange}
      onChange={onChange}
      inputValue={query}
      sortedLocations={locations}
      selected={selected}
      onClick={onClick}
    />
  ) : (
    <Map
      key="map"
      selected={selected
                  || locations[0]}
      locations={locations}
    />
  )

  return (
    <Container>
      <Container header>
        <Search
          onInputChange={onInputChange}
          onChange={onChange}
          inputValue={query}
          loading={userPositionLoading}
        />
      </Container>
      <Container area>
        <Grid
          className={classes.area}
          container
          spacing={0}
        >
          <Grid
            style={{ height : matches ? '50%' : '100%' }}
            item
            lg={3}
            md={4}
            sm={5}
            xs={12}
          >
            {firstComp}
          </Grid>
          <Grid
            style={{ height : matches ? '50%' : '100%' }}
            item
            lg={9}
            md={8}
            sm={7}
            xs={12}
          >
            {secondComp}
          </Grid>
        </Grid>
      </Container>
    </Container>
  )
}

export default App
